import { Button, Form, Modal, Row, Space, notification } from 'antd'
import { InputFields } from 'components/common'
import Icons from "assets/icons";
import React, { useEffect } from 'react';
import { FIELD_TYPE, FORMAT_TIME } from 'types/enums';
import { DataFormField } from 'types/models/input-field-type';
import {payService} from "api";
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { setCallApi } from 'redux/reducer/reduxCommon';
import Notification from 'components/common/notification/notification';
import moment from 'moment';

const {INPUT, SELECT, DATE} = FIELD_TYPE;

const inputItems: DataFormField[] = [
  {
    type: INPUT,
    label: "Lý do hoàn",
    name: "lyDoHoan",
    css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
    labelCol: {xs: 24, sm: 24, md: 2, lg: 2, xl: 2},
    wrapperCol: {xs: 24, sm: 24, md: 22, lg: 22, xl: 22}
  },
];

const ModalAddRefunds = ({isShowModal, handleOk, handleCancel}) => {
  const [formData] = Form.useForm();
  const idData = useAppSelector(state => state.reduxCommon.id);
  const disPath = useAppDispatch();
  const listID = useAppSelector((state) => state.reduxCommon.dataRefunds);

  const onFinish = async value => {
    // console.log("value", value);
    await addRefunds(value);
    disPath(setCallApi());
    handleCancel();
  };

  useEffect(()=>{
    formData.setFieldValue("lyDoHoan", "");
  }, [isShowModal, idData])

  const addRefunds = async (data) => {
    // const newData = {
    //   list_id: listID,
    //   lydohoan: data.lyDoHoan
    // }
    // // console.log('data de nghi hoan phi', newData); 
    // try {
    //   const response = await payService
    //     .suggestionRefunds(newData)
    //     .then(res => {
    //       // console.log("res thêm mới miễn giảm", res);
    //       // notification.success({message: "Thêm thành công"});
    //     });
    // } catch (error) {
    //   Notification("error", "Đã có lỗi xảy ra khi thêm hoàn phí");
    //   
    // }
  }

  const submitRefunds = async (data) => {
    try {
      const response = await payService.suggestionRefunds(data)
      Notification("success", "Đã thêm hoàn phí thành công");
      handleCancel();
      disPath(setCallApi());
    } catch (error) {
      console.log('ERROR', error);
      Notification("error", error.response.data);
    }
  }

  const handleOnSubmitRefunds = async () => {
    const value = await formData.getFieldValue("lyDoHoan");
    const newData = {
      list_id: listID,
      lydohoan: value,
      nguoiDuyetHoan: localStorage.getItem('fullName'),
      thoiGianHoan: moment().format(FORMAT_TIME.dateTime)
    }
    await submitRefunds(newData); 
  }

  return (
    <Modal
      title="Đề nghị hoàn"
      centered
      open={isShowModal}
      onCancel={handleCancel}
      width={"80%"}
      className="modal-tab-pay"
      footer=""
    >
      <div className="table-results">
        <Form form={formData} onFinish={onFinish}>
          <Space direction="vertical" size={"middle"} style={{width: "100%"}}>
            <Form.Item>
              <Row gutter={[16, 8]} justify={"space-between"}>
                <InputFields data={inputItems}></InputFields>
              </Row>
            </Form.Item>
            <Row gutter={[16, 8]} justify={"end"}>
              <Space>
                <Button
                  key="cancel"
                  type="primary"
                  danger
                  onClick={handleCancel}
                >
                  Huỷ bỏ
                </Button>
                {/* <Button
                  key="submit"
                  type="primary"
                  htmlType="submit"
                  icon={<Icons.save rev={0} />}
                  // onClick={handleCancel}
                >
                  Lưu lại
                </Button> */}
                <Button
                  type="primary"
                  onClick={handleOnSubmitRefunds}
                >
                  Duyệt hoàn
                </Button>
              </Space>
            </Row>
          </Space>
        </Form>
      </div>
    </Modal>
  )
}

export default ModalAddRefunds